<h1
  class="mb-3"
  *ngIf="from === 'onboarding'"
  i18n="@@onboarding_createPassword_title"
>
  Create new password
</h1>
<h1 class="mb-3" *ngIf="from === 'reset'" i18n="@@settings_editAccount_title">
  Create new password
</h1>
<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
  <div class="form-group mt-5">
    <label
      *ngIf="from === 'onboarding' || from === 'reset'"
      class="text-uppercase fw-medium"
      for="pwd"
      i18n="@@onboarding_createPassword_formNewPasswordLabel"
    >
      New password
    </label>
    <label
      *ngIf="from === 'account'"
      class="lbl-patient fw-medium"
      for="currentPwd"
      i18n="@@settings_editAccount_formCurrentPasswordLabel"
    >
      Enter your current password
    </label>
    <div
      class="position-relative d-flex align-items-center current-email"
      *ngIf="from === 'account'"
    >
      <input
        class="form-control form-control--password"
        [type]="textType1 ? 'text' : 'password'"
        name="currentPwd"
        id="currentPwd"
        formControlName="currentPwd"
        maxlength="128"
      />
      <span (click)="toggleTextType1()" class="eye-input-normal"
        ><img
          [src]="
            textType1
              ? 'assets/icons/icon-hidden-password.svg'
              : 'assets/icons/icon-visible-password.svg'
          "
          alt="eye"
      /></span>
    </div>
    <label
      class="lbl-patient fw-medium"
      for="pwd"
      *ngIf="from === 'account'"
      i18n="@@settings_editAccount_formNewPasswordLabel"
    >
      New password
    </label>
    <div class="d-flex" [class.align-items-center]="from === 'account'">
      <input
        class="form-control form-control--password"
        [type]="textType ? 'text' : 'password'"
        [class.input-login]="from === 'onboarding' || from === 'reset'"
        i18n-placeholder="@@settings_editAccount_formNewPasswordPlaceholder"
        name="pwd"
        id="pwd"
        formControlName="password"
        maxlength="128"
      />
      <span
        (click)="toggleTextType()"
        [ngClass]="from === 'account' ? 'eye-input-normal' : 'eye-input'"
        ><img
          [src]="
            textType
              ? 'assets/icons/icon-hidden-password.svg'
              : 'assets/icons/icon-visible-password.svg'
          "
          alt="eye"
      /></span>
    </div>

    <div class="rules">
      <span i18n="@@settings_editAccount_passwordRules"
        >This password must include at least :</span
      >
      <ul class="mt-2">
        <li
          [class.valid]="checkPassword(0)"
          i18n="@@settings_editAccount_heightCharacters"
        >
          8 characters
        </li>
        <li
          [class.valid]="checkPassword(3)"
          i18n="@@settings_editAccountoneUppercase"
        >
          1 uppercase
        </li>
        <li
          [class.valid]="checkPassword(4)"
          i18n="@@settings_editAccount_oneLowercase"
        >
          1 lowercase
        </li>
        <li
          [class.valid]="checkPassword(5)"
          i18n="@@settings_editAccount_oneDigit"
        >
          1 digit
        </li>
        <li
          [class.valid]="checkPassword(1)"
          i18n="@@settings_editAccount_oneSpecialCharacter"
        >
          1 special character
        </li>
      </ul>
    </div>
  </div>

  <button
    type="submit"
    [disabled]="!resetPasswordForm.get('password').valid"
    class="btn btn-primary mt-5 w-100 w-md-50 w-lg-75"
  >
    <span
      *ngIf="from === 'onboarding'"
      i18n="@@onboarding_createPassword_validButton"
      >Valid</span
    >
    <span
      *ngIf="from === 'reset'"
      i18n="@@authentication_resetPassword_sendButton"
      >Send</span
    >
    <span *ngIf="from === 'account'" i18n="@@settings_editAccount_saveButton"
      >Save</span
    >
    <span class="icon"
      ><img src="assets/icons/icon-white-arrow-right.svg" alt="arrow"
    /></span>
  </button>
</form>
